import React, { useRef, useState, useEffect } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { getBasketList, getDiscountProduct, addBasket, deleteBasket } from '../../utils/api';
import { Badge } from 'primereact/badge';
import { useNavigate } from 'react-router-dom';
import Basket from '../../assets/icons/shop-card.svg'
import { useCart } from '../../contexts/CartContext';
import ThreeLoader from '../../components/loader/threeDots'
import Trash from '../../assets/icons/trash.svg';
import { Skeleton } from 'primereact/skeleton';
import RedTrash from '../../assets/icons/red-trash.svg'
import Profile from '../../assets/icons/profile.svg';
import LoginComponent from '../../components/login/login'
import RegisterComponent from '../../components/register/register'
import { Dialog } from 'primereact/dialog';
import Logo from '../../assets/images/Mask group.png';
import ProfileSolid from '../../assets/icons/profile-solid.svg';
import PersonalCardSolid from '../../assets/icons/personal-card-solid.svg';
import PersonalCard from '../../assets/icons/personal-card.svg';
const BasketLayout = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);
    const [items, setItems] = useState([]);
    const [totalItems, setTotalItems] = useState('');
    const { cartItems } = useCart();
    const { addToCart } = useCart();
    const [inputValues, setInputValues] = useState({});
    const [loadingQuantities, setLoadingQuantities] = useState({});
    const [selectedDiscount, setSelectedDiscount] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [visible, setVisible] = useState(false); // Dialog visibility state
    const [sectionLogin, setSectionLogin] = useState(false);

    const typingTimers = useRef({});

    useEffect(() => {
        if (cartItems || cartItems === 0) { // بررسی دقیق مقدار 0
            setTotalItems(cartItems); // تعداد محصولات
        } else {
            setTotalItems(cartItems ? parseInt(cartItems, 10) : 0); // مقدار پیش‌فرض
        }
    }, [cartItems]);

    const openBasket = (event) => {
        fetchBasketList()
        setShow(!show);
        setTarget(event.target);
    };

    const closeBasket = () => {
        setShow(false);
    };
    const fetchBasketList = async () => {
        try {
            setIsLoading(true);

            const userId = JSON.parse(localStorage.getItem('userInfo')).si;
            const res = await getBasketList(userId);
            const basketData = res.data;

            const updatedItems = await Promise.all(
                basketData.map(async (item) => {
                    try {
                        const discountRes = await getDiscountProduct(item.Id_Kala);
                        const discounts = discountRes.data || [];

                        let discountPrice = null;

                        for (const discount of discounts) {
                            const nq = discount.Nq;
                            if (nq) {
                                if (nq.includes("از") && nq.includes("تا")) {
                                    const match = nq.match(/از\s*(\d+)\s*تا\s*(\d+)/);
                                    if (match) {
                                        const from = parseInt(match[1]);
                                        const to = parseInt(match[2]);
                                        if (item.Nq >= from && item.Nq <= to) {
                                            discountPrice = discount.Price;
                                            break;
                                        }
                                    }
                                } else if (nq.includes("بیشتراز")) {
                                    const match = nq.match(/بیشتراز\s*(\d+)/);
                                    if (match) {
                                        const from = parseInt(match[1]);
                                        if (item.Nq > from) {
                                            discountPrice = discount.Price;
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                        return {
                            ...item,
                            discounts,
                            DisCountPricePPP: discountPrice || null,
                        };
                    } catch (err) {
                        console.error(`Error fetching discount for ${item.KalaName}`, err);
                        return {
                            ...item,
                            discounts: [],
                            DisCountPricePPP: null,
                        };
                    }
                })
            );

            setItems(updatedItems);
        } catch (error) {
            console.error('Error fetching basket:', error);
        } finally {
            setIsLoading(false);
        }
    };



    useEffect(() => {
        const fetch = async () => {
            await addToCart();
        };
        fetch();
    }, []);
    // const fetchDiscountProduct = async (id) => {
    //     try {
    //         setShow(false); // مخفی کردن اولیه
    //         setSelectedDiscount(null); // پاک کردن مقدار قبلی برای جلوگیری از کش شدن

    //         const res = await getDiscountProduct(id);
    //         if (res.data.length > 0) {
    //             setTimeout(() => {

    //                 setSelectedDiscount({ id, discounts: res.data });
    //                 setShow(true); // نمایش تخفیف جدید
    //             }, 100); // تاخیر کوتاه برای اطمینان از به‌روز شدن مقدار
    //         } else {
    //             setSelectedDiscount(null);
    //             setShow(false);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching discount:', error);
    //     }
    // };
    const findProductBySi = (si) => {
        return items.find((p) => p.Si.toString() === si.toString());
    };

    // useEffect(() => {
    //     if (selectedDiscount && dialogContent.count) {
    //         checkDiscount(dialogContent.count);
    //     }
    // }, [selectedDiscount, dialogContent.count]);

    const handleIncrease = async (product, event) => {
        const newCount = product.Nq + 1;
        setInputValues((prevValues) => ({
            ...prevValues,
            [product.Si]: newCount,
        }));

        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            let res = await addBasket({
                id: product.Id_Kala,
                count: newCount,
                userId: JSON.parse(localStorage.getItem('userInfo')).si
            });
            if (res.status == 200) {
                setTimeout(() => {
                    setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                }, 1000);
                setItems(items.map(p =>
                    p.Si === product.Si ? { ...p, Nq: newCount } : p
                ));
                addToCart()
            }

        } catch (error) {
            console.error('Error increasing product count:', error);
        }
    };

    const handleDecrease = async (product, event) => {
        const newCount = product.Nq - 1;


        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            if (newCount >= product.MinOrder) {
                let res = await addBasket({
                    id: product.Id_Kala,
                    count: newCount,
                    userId: JSON.parse(localStorage.getItem('userInfo')).si
                });
                if (res.status == 200) {
                    setInputValues((prevValues) => ({
                        ...prevValues,
                        [product.Si]: newCount,
                    }));

                    setItems(items.map(p =>
                        p.Si === product.Si ? { ...p, Nq: newCount } : p
                    ));
                    setTimeout(() => {
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                    }, 1000);

                }
            } else {
                let res = await deleteBasket({
                    userId: JSON.parse(localStorage.getItem('userInfo')).si,
                    id: product.Si
                });
                if (res.status == 200) {
                    setItems(items.filter(p => p.Si !== product.Si));

                    setTimeout(() => {
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                    }, 1000);
                    addToCart();
                }


            }


        } catch (error) {
            console.error('Error decreasing product count:', error);
        }
    };


    const deleteItem = async (product) => {
        let res = await deleteBasket({
            userId: JSON.parse(localStorage.getItem('userInfo')).si,
            id: product.Si
        });
        if (res.status == 200) {
            setItems(items.filter(p => p.Si !== product.Si));

            setTimeout(() => {
                setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
            }, 1000);
            addToCart();
        }
    }
    const checkDiscount = (product, count) => {
        if (!product?.discounts?.length) return;

        for (const item of product.discounts) {
            const nq = item.Nq;
            if (nq) {
                if (nq.includes("از") && nq.includes("تا")) {
                    const match = nq.match(/از\s*(\d+)\s*تا\s*(\d+)/);
                    if (match) {
                        const from = parseInt(match[1]);
                        const to = parseInt(match[2]);
                        if (count >= from && count <= to && product.DisCountPricePPP !== item.Price) {
                            setItems(prevItems =>
                                prevItems.map(p =>
                                    p.Si === product.Si
                                        ? { ...p, DisCountPricePPP: item.Price }
                                        : p
                                )
                            );
                            break;
                        }
                    }
                } else if (nq.includes("بیشتراز")) {
                    const match = nq.match(/بیشتراز\s*(\d+)/);
                    if (match) {
                        const from = parseInt(match[1]);
                        if (count > from && product.DisCountPricePPP !== item.Price) {
                            setItems(prevItems =>
                                prevItems.map(p =>
                                    p.Si === product.Si
                                        ? { ...p, DisCountPricePPP: item.Price }
                                        : p
                                )
                            );
                            break;
                        }
                    }
                }
            }
        }
    };


    const handleInputChange = (product, value) => {
        const si = product.Si.toString();
        const numericValue = value.replace(/\D/g, '');

        setInputValues(prev => ({
            ...prev,
            [si]: numericValue,
        }));

        // اگر تایمر قبلی وجود داره، حذف کن
        if (typingTimers.current[si]) {
            clearTimeout(typingTimers.current[si]);
        }

        // شروع تایمر جدید
        typingTimers.current[si] = setTimeout(() => {
            const productObj = findProductBySi(si);
            const parsed = parseInt(numericValue, 10);
            const finalCount = isNaN(parsed) || parsed < productObj.MinOrder ? productObj.MinOrder : parsed;

            setInputValues(prev => ({
                ...prev,
                [si]: finalCount.toString(),
            }));

            handleUpdateBasket(finalCount, productObj);

            // حذف تایمر پس از پایان
            delete typingTimers.current[si];
        }, 1200); // 1.2 ثانیه تأخیر
    };
    const handleUpdateBasket = async (newCount, product) => {

        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            if (newCount >= product.MinOrder) {
                let res = await addBasket({ id: product.Id_Kala, count: newCount, userId: JSON.parse(localStorage.getItem('userInfo')).si });
                if (res.status == 200) {
                    setTimeout(() => {
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                        checkDiscount(product, newCount)
                    }, 2000);
                    setItems(items.map(p =>
                        p.Si === product.Si ? { ...p, Nq: newCount } : p
                    ));
                }

            } else {
                let res = await deleteBasket({
                    userId: JSON.parse(localStorage.getItem('userInfo')).si,
                    id: product.BasketId
                });
                if (res.status == 200) {
                    setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                    setItems(items.map(p =>
                        p.Si === product.Si ? { ...p, Nq: 0 } : p
                    ));
                }

            }
        } catch (error) {
            console.error('Error updating basket:', error);
        }
    };
    // useEffect(() => {
    //     if (items.length > 0) {
    //         items.forEach(item => {
    //             checkDiscount(item, item.Nq);
    //         });
    //     }
    // }, [items]);

    return (
        <>  <div ref={ref}>
            <div style={{ position: 'relative' }}>
                <button onClick={openBasket} className='btn p-0 basket-icon  btn-outline-primary w-[48px] d-flex align-items-center justify-center' style={{ padding: '2px' }}><img src={Basket} alt="" /></button>
                {totalItems > 0 && <div>
                    <Badge className='number badge-icon' value={totalItems} severity="danger" style={{ position: 'absolute', top: '-1em', right: '-0.5em' }}></Badge>

                </div>}

            </div>

            <Overlay
                rootClose={true}
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                onHide={closeBasket}
            >
                <Popover id="popover-contained" className='w-[500px]'>

                    {localStorage.getItem('userInfo') ? (
                        <div className="p-2" style={{ maxHeight: '50vh', overflow: 'auto' }}>
                            <div className='d-flex align-items-center justify-content-end '>
                                <button className='btn btn-primary w-100' style={{ height: '38px' }} onClick={() => navigate('/orders')}>رفتن به سبد خرید</button>

                            </div>
                            {isLoading ? (
                                <div className="flex flex-col gap-3 mt-3">
                                    {[...Array(3)].map((_, index) => (
                                        <div key={index} className="flex gap-3 items-center border-b-[1px] border-b-[#E5ECFF] border-dashed pb-2">
                                            <Skeleton shape="rectangle" className='aspect-[4/4]' width="45px" height="45px" />
                                            <div className="flex flex-col gap-2 w-full">
                                                <Skeleton width="60%" height="1rem" />
                                                <Skeleton width="40%" height="0.8rem" />
                                            </div>
                                            <div className="flex gap-2">
                                                <Skeleton width="32px" height="32px" />
                                                <Skeleton width="32px" height="32px" />
                                                <Skeleton width="32px" height="32px" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <>
                                    {items && items.length > 0 ? (
                                        <>

                                            <div>
                                                {items.map(item => (
                                                    <div key={item.productId} className='flex gap-2 items-end justify-between gap-3 border-b-[1px] border-b-[#E5ECFF] border-dashed py-3 last:border-b-0 position-relative'>
                                                        <div className='delete-box' onClick={(e) => deleteItem(item)}>
                                                            <img src={RedTrash} alt="" width={10} />
                                                        </div>
                                                        <div className='flex gap-2 items-start gap-3'>
                                                            <div>
                                                                <div className="relative overflow-hidden rounded aspect-[4/4] w-[45px]">
                                                                    <img src={item.Pic_A} alt="" />
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start justify-between min-w-[10em]'>
                                                                <div className='font-bold mb-2'>
                                                                    {item.KalaName}
                                                                </div>
                                                                <div className='align-items-center gap-3 justify-content-center'>
                                                                    <div className={`${(item.DisCountPricePPP && item.DisCountPricePPP != item.Price) ? 'discount-price' : ''} mt-2 number-font`}>{parseInt(item.Price).toLocaleString()} تومان</div>
                                                                    {(item.DisCountPricePPP && item.DisCountPricePPP != item.Price) && (

                                                                        <div className='mt-2 number-font'>{parseInt(item.DisCountPricePPP).toLocaleString()} تومان</div>)}

                                                                </div>

                                                            </div>


                                                        </div>
                                                        <div className='text-center d-flex justify-content-center'>
                                                            <div className='d-flex align-items-center justify-content-center gap-2 increas basket-list w-fit'>
                                                                <button className='btn btn-primary w-[32px]' style={{ width: '32px', height: '32px', fontSize: '10px' }} onClick={() => handleIncrease(item)}>+</button>
                                                                {loadingQuantities[item.Si] ? (
                                                                    <div className='form-control w-[32px] h-[32px] text-center d-flex align-items-center justify-content-center' style={{ width: '32px', height: '32px' }}>
                                                                        <ThreeLoader />

                                                                    </div>
                                                                ) : (
                                                                    <input
                                                                        className={`form-control w-[32px] h-[32px] text-center number-font`}
                                                                        style={{ height: '32px', width: '32px' }}
                                                                        value={inputValues[item.Si] ?? item.Nq}
                                                                        onChange={(e) => handleInputChange(item, e.target.value)}

                                                                    />
                                                                )}



                                                                <button className='btn btn-primary w-[32px] d-flex align-items-center justify-center' style={{ width: '32px', height: '32px', fontSize: '10px' }} onClick={() => handleDecrease(item)}>
                                                                    {item.Nq === item.MinOrder ? <img src={Trash} width={18} /> : '-'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                        </>
                                    ) : (
                                        <div className='dont-bold text-center'>
                                            محصولی در سبد خرید شما وجود ندارد !
                                        </div>
                                    )}
                                </>

                            )}
                        </div>
                    ) : (
                        <div  className="p-4" style={{ maxHeight: '50vh', overflow: 'auto' }}>
                             <div className='dont-bold text-center'>
                                            برای مشاهده سبد خرید ابتدا وارد شوید!
                                        </div>
                                <button className='btn btn-primary d-flex align-items-center w-100 mt-3' onClick={(event) => {
                            setVisible(true)
                        }}><img src={Profile} style={{ marginLeft: '3px' }} alt="" />{
                                localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).fullname : 'ورود'
                            }</button> 
                        </div>
                   
                    )}

                </Popover>
            </Overlay>
        </div>
            <Dialog
                draggable={false}
                visible={visible}
                style={{ width: '40vw' }}
                breakpoints={{ '60vw': '60vw', '80vw': '90vw' }}
                onHide={() => setVisible(false)}
                className='login-dialog'
                dismissableMask
            >
                <div className='text-center'>
                    <img src={Logo} alt="" className='mx-auto' width={96} />
                    <div className='d-flex align-items-center justify-between mt-3 w-[85%] mx-auto gap-3 max-md:!w-full'>
                        <button className={`${sectionLogin == 0 ? 'btn-primary' : 'btn-outline-primary'
                            } btn w-50 d-flex align-items-center justify-center gap-2`} onClick={() => { setSectionLogin(0) }}> <img src={sectionLogin == 0 ? Profile : ProfileSolid} alt="" width={20} />ورود</button>
                        <button className={`${sectionLogin == 1 ? 'btn-primary' : 'btn-outline-primary'
                            } btn w-50 d-flex align-items-center justify-center gap-2`} onClick={() => { setSectionLogin(1) }}> <img src={sectionLogin == 1 ? PersonalCardSolid : PersonalCard} alt="" width={20} />ثبت نام</button>
                    </div>


                    {sectionLogin == 0 ? (
                        <>
                            <LoginComponent />
                        </>
                    ) : (
                        <>
                            <RegisterComponent />
                        </>
                    )

                    }
                </div>
            </Dialog>


        </>

    );
};

export default BasketLayout;
